import { graphql, useStaticQuery } from 'gatsby'

const query = graphql`
	query useAllSdkVersionsQuery {
		allSdkVersion {
			edges {
				node {
					sdkId
					version
				}
			}
		}
	}
`

const useAllSdkVersionsQuery = () => {
	const data = useStaticQuery(query)
	return data.allSdkVersion.edges.map(edge => edge.node)
}

export default useAllSdkVersionsQuery
